import { render, staticRenderFns } from "./SentimentModelStatisticsItem.vue?vue&type=template&id=7741dbb6&"
import script from "./SentimentModelStatisticsItem.vue?vue&type=script&lang=js&"
export * from "./SentimentModelStatisticsItem.vue?vue&type=script&lang=js&"
import style0 from "./SentimentModelStatisticsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports